import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, testId }) => (
  <section data-testid={testId} className="relative bg-[#0A192F] text-white overflow-hidden grain">
    <div className="absolute inset-0 grid-lines" />
    <div className="absolute -bottom-40 -left-20 w-[50vw] h-[50vw] rounded-full bg-sky-500/10 blur-[120px]" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-36 sm:pt-44 pb-20 md:pb-28 grid lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-8">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="eyebrow text-sky-300 mb-6">{eyebrow}</motion.p>
        <MaskLines as="h1" inView={false} delay={0.15} className="text-5xl sm:text-7xl lg:text-8xl font-extrabold tracking-[-0.045em] leading-[0.92]" lines={lines} />
      </div>
      <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8, duration: 0.8 }}
        className="lg:col-span-4 text-slate-300 text-base md:text-lg leading-relaxed">{intro}</motion.p>
    </div>
  </section>
);
